import { CoreService } from "./../../base/core";
import { Observable } from "rxjs";
import { Injectable, EventEmitter, Output } from "@angular/core";

import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { ITermInfoByCourseType } from "src/app/interfaces/termInfoByCourseType";
import { ITermInfo } from "src/app/interfaces/term-info";
import { ITermInfoStaus } from "src/app/interfaces/term-info-status";

@Injectable({
  providedIn: "root"
})
export class TermInfoService {
  @Output() change: EventEmitter<boolean> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  @Output() exp: EventEmitter<any> = new EventEmitter();

  constructor(private coreService: CoreService) { }

  // list(page: number = 1, pageSize: number = 10): Observable<any> {
  //   return this.coreService.get(
  //     ServiceRoute.termInfo.list,
  //     new CommonHttpOption().headers,
  //     new CommonHttpOption().paginator(page, pageSize, 'TermNumber', true)
  //   );
  // }
  list(filter: any, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.termInfo.list,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(page, pageSize, 'TermNumber', true)
        .append('CourseTypeId', filter && filter.CourseTypeId ? filter.CourseTypeId : '')
        .append('StartDate', filter && filter.StartDate ? filter.StartDate : '')
        .append('EndDate', filter && filter.EndDate ? filter.EndDate : '')
        .append('ParentTermId', filter && filter.ParentTermId ? filter.ParentTermId : '')
        .append('EduPersianYear', filter && filter.Year ? filter.Year : '')
        .append('Title', filter && filter.Title ? filter.Title : '')
    );
  }

  getListById(id: string, pageIndex: number, pageSize: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.termInfo.list,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize)
        .append('ParentTermId', id ? id : '')
    );
  }

  getListComboById(id: string, pageIndex: number, pageSize: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.termInfo.listCombo,
      new CommonHttpOption().headers,
      new CommonHttpOption()
        .paginator(pageIndex, pageSize)
        .append('ParentTermId', id ? id : '')
    );
  }

  ListByCourseTypeId(data: ITermInfoByCourseType): Observable<any> {
    return this.coreService.post(
      ServiceRoute.termInfo.listByCourseTypeId,
      data,
      new CommonHttpOption().headers
    );
  }

  getById(id: number): Observable<any> {
    return this.coreService.get(
      ServiceRoute.termInfo.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: ITermInfo): Observable<any> {
    return this.coreService.post(
      ServiceRoute.termInfo.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ITermInfo): Observable<any> {
    return this.coreService.put(
      ServiceRoute.termInfo.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  StatusForEdit(data: ITermInfoStaus): Observable<any> {
    return this.coreService.put(
      ServiceRoute.termInfo.StatusForEdit,
      data,
      new CommonHttpOption().headers
    );
  }

  ToggleTerm(data: ITermInfoStaus): Observable<any> {
    return this.coreService.put(
      ServiceRoute.termInfo.ToggleTerm,
      data,
      new CommonHttpOption().headers
    );
  }

  ToggleTermInParentTerm(data: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.termInfo.ToggleTermInParentTerm,
      data,
      new CommonHttpOption().headers
    );
  }

  ToConfirmTerm(data: ITermInfoStaus): Observable<any> {
    return this.coreService.put(
      ServiceRoute.termInfo.ToConfirmTerm,
      data,
      new CommonHttpOption().headers
    );
  }

  delete(data: any): Observable<any> {
    return this.coreService.delete(
      ServiceRoute.termInfo.delete,
      new CommonHttpOption().headers,
      data
    );
  }

  listByJustCourseTypeId(data: {}): Observable<any> {
    return this.coreService.post(
      ServiceRoute.termInfo.listByJustCourseTypeId,
      data,
      new CommonHttpOption().headers
    );
  }

  fire(e) {
    this.change.emit(e);
  }

  expFire(e) {
    this.exp.emit(e);
  }

  closeModal() {
    this.close.emit();
  }
}
